import NewRetailer from "../../../../components/@users/retailers/NewRetailer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailerNewPage() {

    return (
        <NewRetailer 
            routeType={routeTypes.admin}
        />
    )
}       